<template>
  <div class="wrapper-calcway wh100p">
    <section class="section-navs df-c-fs">
      <div class="back-btn _themecolor f-m df-c-ct" @click="$router.go(-1)">
        <img class="arrow" :src="iconArrowLeft">
        <div>{{$t('calc.calcWay2')}}</div>
      </div>
      <div class="cancel-btn df-c-ct">
        <div class="whitebtn" @click="cancelOrderClick">
          {{[8,9,10,100].includes(orderData.status)?$t('calc.cancelCalcAndRefund'):$t('food.cancelCalc')}}
        </div>
      </div>
      <div class="code f1 df-c-sb mr60 sls">
        <div class="f1 df-c-ct _themecolor f-bold f-l" style="width:40px;">{{orderData.code}}</div>
        <div class="f1 df-l-fs ai-fe sls">
          <div class="df _themecolor f-bold">
            <span>{{$t('calc.total')}}：</span>
            <span class="f-l">{{orderData.userCost|toprice}}</span>
            <span class="plr10"> / </span>
            <span>{{$t('calc.unassigned')}}：</span>
            <span class="f-l">{{orderData.unassignCash|toprice}}</span>
          </div>
          <div class="coupon-text df-fe sls" v-if="orderData.bindTicketNameList&&orderData.bindTicketNameList.length">
            <span class="f-gray sls">{{orderData.bindTicketNameList.join('，')}}</span>
          </div>
        </div>
      </div>
      <img src="@/assets/icons/add.png" class="iconadd" @click="createSubOrder">
    </section>

    <section class="section-cons df scrollx">
      <div class="section-conbox f1 transition" v-for="(x0,i0) in childOrders" :key="i0">
        <section class="section-con df-l-fs ai-fe scrolly h100p transition" :class="{'section-con-m':orderCount>2}">

          <img src="@/assets/icons/subtract.png" class="iconsubtract" v-if="!x0.payed" @click="cancelThisChildOrder(i0)">

          <div class="section-scroll w100p f1 df-l-fs">
            <div class="section-orderNo df-c-sb" :class="{'section-orderNo2':isShowMember&&orderCount>2,'section-orderNo3':!isShowMember}">
              <!-- 关联会员 -->
              <div v-if="isShowMember" class="df-c-fs customer" :class="{'customer2':orderCount<3}">
                <div class="df-c-ct w100p" v-if="x0.customerObj&&x0.customerObj.customerId">
                  <div class="f-s sls w100p" style="margin-right:10px;">{{x0.customerObj.customerName}}</div>
                  <img
                    class="rotate45" style="width:24px;height:24px;margin-right:12px;"
                    src="@/assets/icons/add1.png" @click="clearOrderCustomer(i0)" />
                </div>
                <div class="themebtn-s btn" @click="bindOrderCustomer(i0)" v-else-if="!x0.payed">{{$t('member.bindMember')}}</div>
              </div>
              <!-- 订单号 -->
              <div class="orderNo">{{orderCount>2?'':($t('order.orderNo')+'：')}}{{x0.orderNo}}{{x0.subOrderId?'-'+x0.subOrderId:''}}</div>
            </div>
            <!-- 優惠券 -->
            <div class="section-coupon w100p df-sb">
              <div class="left df-c-fs" @click="openCouponsSelectDialog2(i0)">
                <div class="df-c-fs">
                  <img style="width:24px;height:24px;margin-right:12px;" src="@/assets/icons/discount.png" />
                  <div :class="lang==='en'?'f-s':'f-m'" v-show="orderCount<3">{{$t('coupon.discountCode')}}</div>
                </div>
              </div>
              <div class="right f1 df-l-fs ai-fe">
                <div class="w100p df-l-fs ai-fe" v-for="(x,i) in x0.couponsArr" :key="i">
                  <div class="df-c-fs">
                    <img
                      class="iconcoupon"
                      style="margin-right:12px;"
                      :style="orderCount>2?'width:30px;height:30px;':'width:40px;height:40px;'"
                      :src="iconCheckCoupon"
                      @click="openCouponsSelectDialog(i0,i)"
                      v-if="x0.customerObj&&x0.customerObj.customerId&&!x.code" />
                    <input
                      class="input wh100p f-xs" :placeholder="orderCount<4?$t('coupon.inputDiscountCode'):''"
                      v-model="x.code" @focus="onFocus_forScan" @blur="searchCoupon(i0,i)" :disabled="x0.payed||x.dis" />
                  </div>
                  <div class="w100p df-c-fe">
                    <div class="text sls f-xs" :class="{'_themecolor':x.success,'_redcolor':!x.success}">{{x['desc'+_lang]}}</div>
                    <img class="iconcoupon" :src="iconAdd2" @click="addCoupon(i0,i,1)" v-if="!x0.payed" />
                    <img class="iconcoupon" :src="iconSubtract2" @click="addCoupon(i0,i,-1)" v-if="!x0.payed" />
                  </div>
                </div>
              </div>
            </div>
            <!-- 购物车商品 -->
            <div class="section-items w100p">
              <div class="item sls df" v-for="(x,i) in x0.orderItemDetailList" :key="i">
                <div class="f1 sls" :class="{'filtergray':x0.payed}">
                  <div :class="orderCount>2?'df-l-fs ai-fe':'df-c-sb'">
                    <div class="text sls w100p df-c-fs">
                      <div class="name sls f1 f-m">{{x['itemName'+_lang]}}</div>
                    </div>
                    <div class="text sls w100p df-c-sb">
                      <div class="num">X{{x.count|tothousands}}</div>
                      <div class="text price f-m">{{(x.count*x.itemPrice)|toprice(2)}}</div>
                    </div>
                  </div>
                  <CartItemDetail :item="x" :fontSize="orderCount>2?12:16" />
                </div>
              </div>
            </div>
          </div>
          <!-- 价格信息 -->
          <div class="section-total w100p df-l-fs ai-fe">
            <div class="df-c-sb w100p">
              <div class="text pad f-xxs">{{$t('calc.shouldPay')}}：</div>
              <div class="text pad f-xxs f-silvery">{{$t('common.price')}}：{{x0.costOrigin|toprice(2)}}</div>
            </div>
            <template v-if="x0.stripeTerminal">
              <div class="df-c-fs">
                <div class="text pad f-xxs f-silvery">{{$t(x0.serviceFee?'common.tipServiceFee':'common.tip')}}：</div>
                <div class="edit-btn df-c-ct f-white _themebackground" @click.stop.prevent="tipClickHandler(x0)">{{(x0.tipsFee+x0.serviceFee)|toprice(2)}}</div>
              </div>
            </template>
            <div class="text pad f-xxs f-silvery" v-if="x0.discountFee">{{$t('common.discount')}}：-{{x0.discountFee|toprice(2)}}</div>
            <div class="text pad f-xs f-silvery">{{$t('common.total')}}：<span class="text f-xs _redcolor">{{x0.userCost|toprice(2)}}</span></div>
          </div>
          <!-- 结算按鈕 -->
          <div class="section-btns w100p df-w-c-fe">
            <div class="btn" :class="orderCount>2?'whitebtn-s':'whitebtn'" @click="printOrderClick(x0,i0)">{{$t('common.print')}}{{orderCount>2?'':$t('food.order')}}</div>
            <div class="btn" :class="orderCount>2?'themebtn-s':'themebtn'" @click="createPayment(i0)" v-if="!x0.payed">{{$t('common.pay')}}</div>
            <div class="btn" :class="orderCount>2?'redbtn-s':'redbtn'" @click="refundOrderClick(i0)" v-else>
              <div :class="orderCount>2?'lh20 f-xxxs':'lh25 f-xxs'">{{$t('common.refund')}}</div>
              <div :class="orderCount>2?'lh20 f-xxxs':'lh25 f-xxs'">{{x0.payTypeNameList[0]['name'+_lang]}}</div>
            </div>
          </div>

        </section>
      </div>
    </section>

    <Dialog
      ref="Dialog_way"
      :dialogTitle="$t('calc.byCustom')">
      <!-- contentWidth="700"
      :closeable="false"
      @close="isCouponOk=true" -->
        <div class="mydialog1 df-l-fs" slot="content">
          <div class="info df-c-fs">
            <div class="f-dark f-xs">{{$t('calc.totalPrice')}}：{{orderData.userCost|toprice(2)}}</div>
            <div class="f-dark f-xs">{{$t('calc.unassigned')}}：{{orderData.unassignCash|toprice(2)}}</div>
          </div>
          <div class="df-l-c-fs" style="position:relative;">
            <InputCustom
              class="mb20"
              :inputable="true"
              inputWidth="620"
              inputHeight="50"
              :inputPlaceholder="$t('calc.inputCustomPrice')"
              :inputValue="moneyNumber" />
            <Keyboard :inputValue.sync="moneyNumber" :decimalPlaces="{us:2,hk:1}[sysEnv_x]" priceModel />
            <div class="inputallleftcash df-c-ct" @click="toggleIsInputAllLeftCash">
              <img :src="isInputAllLeftCash?iconCheckok:iconChecknull" style="width:20px;height:20px;margin-right:10px;">
              <div class="f-xs">{{$t('calc.payLeft')}}</div>
            </div>
          </div>
        </div>
        <template slot="footer">
          <div class="themebtn" @click="createSubOrder_">{{$t('common.comfirm')}}</div>
        </template>
    </Dialog>

    <DialogPay ref="DialogPay" @close="clearPayment" />

    <DialogKey ref="DialogKey" />

    <DialogPayway ref="DialogPayway" @submitDialog="submitDialogPayway" />

    <DialogTip ref="DialogTip" @submitDialog="getSubOrder" />

  </div>
</template>

<script>
import DialogPayway from '@/components/DialogPayway'
import DialogPay from './components/DialogPay'
import coupon from '@/mixins/coupon_split'
const COUPON_EMPTY = {desc_zh:'',desc_en:'',code:'',status:-1,price:0}
export default {
  name: 'calcwayCus',
  mixins: [coupon],
  components: { DialogPayway, DialogPay },
  data() {
    return {
      tableData: {}, // 餐桌
      orderData: {}, // 订单

      childOrders: [], // 所有订单的集合

      dialogCash: 0, // 支付彈框需要的价格

      clearPaymentTimer: null,

      moneyNumber: '',
      isInputAllLeftCash: false,
    }
  },
  computed: {
    orderCount() {
      return this.childOrders.length
    },
    orderPaidCount() {
      return this.childOrders.filter(x => x.payed).length
    },
  },
  watch: {
    moneyNumber(nval, oval) {
      if (String(this.orderData.unassignCash) === nval) {
        this.isInputAllLeftCash = true
      } else { 
        this.isInputAllLeftCash = false
      }
    },
  },
  methods: {
    // #region 改变支付渠道
    submitDialogPayway() {
      this.sendPayCallback(this.childOrders[this.focusIndex1].id)
      this.$refs.DialogKey.close()
    },
    // #endregion

    // #region 子订单
    // 创建子订单
    createSubOrder() {
      this.moneyNumber = ''
      this.$refs.Dialog_way.open()
    },
    // 分菜 全选剩余金额
    toggleIsInputAllLeftCash() {
      this.isInputAllLeftCash = !this.isInputAllLeftCash
      if (this.isInputAllLeftCash) {
        this.$nextTick(() => {
          this.moneyNumber = String(this.orderData.unassignCash)
        })
      } else {
        this.$nextTick(() => {
          this.moneyNumber = ''
        })
      }
    },
    createSubOrder_() {
      console.log(`%cthis.moneyNumber:`, 'color: #f00;', this.moneyNumber)
      if (Number(this.moneyNumber) === 0) {
        this.$message.warning(this.$t('calc.moneyNumberError'))
        return
      }
      this.$api.sub_order_create({
        shopId: this.currentShopId,
        orderId: this.orderData.id,
        userCost: this.moneyNumber
      }).then(async res => {
        if (res.status == 0) {
          let _R = res.data
          console.log(_R)
          _R.couponsArr = [JSON.parse(JSON.stringify(COUPON_EMPTY))]
          _R.customerObj = {
            customerId: '',
            customerName: '',
            allCoupons: [],
            okCouponCodes: [],
            failedCouponCodes: [],
          }
          _R.isCouponOk = true
          await this.judgeCart()
          this.childOrders.push(_R)
          this.$refs.Dialog_way.close()
          this.moneyNumber = ''
        } else { this._status(res) }
      })
    },
    // 删除子订单
    async cancelThisChildOrder(index1) {
      // 服务器判断此单是否是唯一一个未结算的单，是则终止，否则弹框
      const _D = await this.delData('order', {
        shopId: this.currentShopId,
        id: this.childOrders[index1].id
      })
      if (_D === 'ok') {
        await this.judgeCart()
        this.getSubOrder()
      }
    },
    // 计算子订单价格
    childOrderCostCalc(indexArr) {
      let rD = {}, ticketCodeList = []
      let targetArr = []
      if (indexArr) {
        targetArr = indexArr
      } else {
        this.childOrders.forEach((x1, i1) => {
          if (!x1.payed) {
            targetArr.push(i1)
          }
        })
      }
      targetArr.forEach(async idx => {
        const ORDER = this.childOrders[idx]

        ORDER.couponsArr && ORDER.couponsArr.forEach(x2 => {
          x2.code && x2.code !== this.$t('coupon.noCoupon') && ticketCodeList.push(x2.code)
        })
        rD = {
          shopId: this.currentShopId,
          parentOrderId: this.orderData.id,
          id: ORDER.id,
          userCost: ORDER.userCost
        }
        ticketCodeList.length > 0 && (rD.ticketCodeList = ticketCodeList)
        // console.log(`%c计算子订单价格index+rD:`, 'color: #f00;', idx, rD)
            
        const CUSTOMER = ORDER.customerObj
        if (CUSTOMER && CUSTOMER.customerId) {
          rD.customerId = CUSTOMER.customerId
        }

        return this.$api.order_cost_calc(rD).then(res => {
          if (res.status == 0) {
            let _R = res.data
            
            
            console.log(`%c计算子订单价格:`, 'color: #00f;', _R, _R.resultList)
            this.childOrders[idx].serviceFee = _R.serviceFee
            this.childOrders[idx].tipsFee = _R.tipsFee
            this.childOrders[idx].costOrigin = _R.costOrigin
            this.childOrders[idx].discountFee = _R.discountFee
            this.childOrders[idx].consumptionTax = _R.consumptionTax
            this.childOrders[idx].tip = _R.tip
            this.childOrders[idx].takeOutDiscountFee = _R.takeOutDiscountFee
            this.childOrders[idx].userCost = _R.price

            this.childOrders[idx].isCouponOk = true
            // this.childOrders[idx].stripeTerminal = true

            let resultList_ = JSON.parse(JSON.stringify(_R.resultList)).reverse()

            resultList_.forEach(x1 => {
              if (CUSTOMER.allCoupons.length) {
                const COUPON = CUSTOMER.allCoupons.find(x2 => x2.code === x1.code)
                if (COUPON) {
                  this.$set(COUPON, 'canUse', false)
                }
              }
            })


            ORDER.couponsArr && ORDER.couponsArr.forEach(x2 => {
              const COUPON = resultList_.find(x3 => x3.code === x2.code)
              const COUPON_INDEX = resultList_.findIndex(x3 => x3.code === x2.code)
              // console.log(`%c与返回的优惠券匹配:`, 'color: #f0f;', COUPON)
              if (COUPON) {
                if (COUPON.status === 0) {
                  x2.success = true
                  const {
                    ticketType,
                    atLeastCost,
                    discountCash,
                    discount,
                    afterCost,
                    afterCash
                  } = COUPON.discountTicket
                  let descPrefix_zh = '', descPrefix_en = ''
                  if (atLeastCost) {
                    descPrefix_zh = '滿$' + atLeastCost
                    descPrefix_en = 'Spend $' + atLeastCost
                  }
                  switch (ticketType) {
                    case 1:
                      x2.desc_zh = descPrefix_zh + '立減$' + discountCash
                      x2.desc_en = descPrefix_en + ' Enjoy Discount $' + discountCash
                      break
                    case 2:
                      x2.desc_zh = descPrefix_zh + '立打' + discount + '折'
                      x2.desc_en = descPrefix_en + ' Enjoy ' + (10 - discount) * 10 + '% Discount Off'
                      break
                    case 3:
                      if (afterCost) {
                        x2.desc_zh = descPrefix_zh + '立返' + afterCost + '%'
                        x2.desc_en = descPrefix_en + ' Get $' + afterCost + '%'
                      } else {
                        x2.desc_zh = descPrefix_zh + '立返$' + afterCash
                        x2.desc_en = descPrefix_en + ' Get $' + afterCash
                      }
                      break
                    case 4:
                      x2.desc_zh = descPrefix_zh + '免单'
                      x2.desc_en = 'Free when spend $' + atLeastCost + ' or more'
                      break
                  }
                  x2.status = COUPON.status
                } else {
                  x2.success = false
                  x2.desc_zh = COUPON.msg
                  x2.desc_en = COUPON.msg_en
                  x2.status = COUPON.status
                  this.childOrders[idx].isCouponOk = false
                }
              } else {
                // JSON.parse(JSON.stringify(COUPON_EMPTY))
                x2.desc_zh = ''
                x2.desc_en = ''
                x2.status = -1
                this.childOrders[idx].isCouponOk = true
              }
              resultList_.splice(COUPON_INDEX, 1)
            })



          } else { this._status(res) }
        })

      })
    },
    // #endregion

    // #region 小费
    tipClickHandler(row) {
      if (row.stripeTerminal) {
        this.$refs.DialogTip.open(row.id, row.serviceFee, row.tipsFee)
      }
    },
    // #endregion

    // #region 打印
    // 打印订单
    printOrderClick(item, index1) {
      // console.log(this.rowSelected)
      if (this.printerId_x) {
          
        let ticketCodeList = [], rD = {
          shopId: this.currentShopId,
          id: item.id,
          printerCustomerSignature: !!item.payed
        }
        item.couponsArr.forEach(x => {
          x.code && x.code !== this.$t('coupon.noCoupon') && ticketCodeList.push(x.code)
        })
        ticketCodeList.length > 0 && (rD.ticketCodeList = ticketCodeList)

        this.$api.print_order_food(rD, this.printerId_x).then(res => {
          if (res.status == 0) {
          } else { this._status(res) }
        })
      } else { this.$message.warning(this.$t('print.printerError')) }
    },
    // #endregion

    // #region 支付
    // 提交结算
    createPayment(index1) {
      this.focusIndex1 = index1
      this.dialogCash = this.childOrders[this.focusIndex1].userCost || 0

      // 如果当前點擊的分單優惠券無誤
      if (this.childOrders[index1].isCouponOk) {
        switch (this.orderData.status) {
          case 1: case 2: case 3:
          case 6:
          case 4: case 7:
            this.$api.payment_cash_enter({
              shopId: this.currentShopId,
              id: this.orderData.id,
            }).then(res => {
              if (res.status == 0) {
                let _R = res.data
                console.log(_R, _R.status)
                this.orderData.status = _R.status
                console.log(`%c设置为分钱 订单+状态:`, 'color: #00f;', _R, _R.status)
              } else { this._status(res) }
            })
          case 5: case 8: case 10:
            let { id, customerObj } = this.childOrders[this.focusIndex1]
            this.$refs.DialogPay.open({
              cash: this.dialogCash,
              poid: id,
              uid: customerObj.customerId || '',
            })
            break
          case 9: this.$message.warning(this.$t('calc.paidPartByFood')); break
          // case 10: this.$message.warning(this.$t('calc.paidPartByCustom')); break
        }
      } else {
        this.$message.warning(this.$t('calc.couponError'))
      }


    },
    // 创建支付订单
    createChildOrder(eftPay) {
      let { id, orderItemDetailList, subOrderId, couponsArr, customerObj } = this.childOrders[this.focusIndex1]
      let rD = {
        shopId: this.currentShopId,
        orderId: id,
        orderItemDetailList,
        subOrderId
      }
      eftPay && (rD.eftPay = true)

  
      let ticketCodeList = []
      couponsArr.forEach(x => {
        x.code && x.code !== this.$t('coupon.noCoupon') && ticketCodeList.push(x.code)
      })
      ticketCodeList.length > 0 && (rD.ticketCodeList = ticketCodeList)

      if (customerObj && customerObj.customerId) {
        rD.customerId = customerObj.customerId
      }

      return this.$api.payment_create(rD).then(res => {
        if (res.status == 0) {
          let _R = res.data
          console.log(`%cpayment_create:`, 'color: #00f;', _R, _R.status)
          this.orderData_new = _R
          return _R.id
        } else { this._status(res) }
      })
    },
    async sendPayCallback(id) {
      if (!id) return
      const _Rs = await this.getData('order', {
        shopId: this.currentShopId,
        id
      })
      let _R = _Rs[0]
      if (_R) {
        this.childOrders[this.focusIndex1].payTypeList = _R.payTypeList
        this.childOrders[this.focusIndex1].payTypeNameList = _R.payTypeNameList
        this.childOrders[this.focusIndex1].stripeTerminal = _R.stripeTerminal
        this.childOrders[this.focusIndex1].status = _R.status
        this.childOrders[this.focusIndex1].payedWith3rd = _R.payedWith3rd
      }
      this.childOrders[this.focusIndex1].payed = true
    },
    // 支付对话框 关闭支付结果
    async clearPayment() {
      await this.judgeCart()
      // console.log(this.orderData.status)
      if (this.orderData.status === 100) {
        
        this.$message.success(this.$t('pay.finPay'))

        this.clearPaymentTimer = setTimeout(() => {
          // console.log(this.homePage_x, this.fromPage)
          if (this.homePage_x === 'table') {
            switch (this.fromPage) {
              case 'table': this.$router.go(-2); break
              case 'menu': this.$router.go(-3); break
              case 'order': this.$router.go(-2); break
              default: this.$router.replace('table'); break
            }
          } else if (this.homePage_x === 'menu') {
            switch (this.fromPage) {
              case 'menu': this.$router.go(-2); break
              case 'order': this.$router.go(-2); break
              default: this.$router.replace('menu'); break
            }
          }
          clearTimeout(this.clearPaymentTimer)
        }, 2000)
      } else if (!this.isShowNewWindow) {
        // 2023-12-5 17:54:22 支付成功弹框改为绿色消息
        this.$message.success(this.$t('pay.paySuccess'))
      }
    },
    // #endregion

    // #region 退款
    refundOrderClick(index1 = '') {
      this.focusIndex1 = index1
      const order = this.childOrders[this.focusIndex1]
      this.$refs.DialogKey.open({
        orderId: this.orderData.id,
        sceneType: 1,
        onConfirm: this.sendAjax_refund,
        showChangePayway: this.isShowWhetherOpenPayment
          && order
          && order.status===100
          && !order.payedWith3rd,
        onChange: () => {
          this.$refs.DialogPayway.open(order)
        }
      })
    },
    async sendAjax_refund() {
      const ORDER = this.focusIndex1 !== '' ? this.childOrders[this.focusIndex1] : this.orderData

      const _Rs = await this.getData('order', {
        relatedSubOrderId: ORDER.id,
        payed: true,
        returnCash: false,
        eftPay: true,
        subOrder: false,
      })
      if (_Rs && _Rs.length) {
        _Rs.forEach(x1 => {
          const { id: orderId, payType, userCost } = x1
          this.sendAjax_eftRefund({ orderId, payType, userCost }).then(() => {
            this.sendAjax_refund_send(ORDER)
          })
        })
      } else {
        console.log('没有支付订单')
        this.sendAjax_refund_send(ORDER)
      }
    },
    sendAjax_refund_send(ORDER) {
      this.judgeCashPayed(ORDER)

      this.$api.order_refund({
        shopId: this.currentShopId,
        id: ORDER.id,
      }).then(res => {
        if (res.status == 0) {
          if (this.focusIndex1 !== '') {
            ORDER.payed = false
            ORDER.status = 1
            this.judgeCart()
          } else {
            this.$router.go(-1)
          }
        } else { this._status(res) }
      })
    },
    // #endregion

    judgeCashPayed(ORDER) {
      console.log(ORDER)
      if (ORDER.payTypeList && ORDER.payTypeList.includes(5)) {
        console.log('尝试打开钱箱')
        this.$tool.dsbridge_call(this.$tool.dsbridge_map.openCashDrawer, '')
      }
    },

    // #region eft退款
    sendAjax_eftRefund({ orderId, payType, userCost }) {
      return new Promise(async (resolve, reject) => {
        
        let rD = {
          shopId: this.currentShopId,
          orderId,
          payType,
          userCost,
          ip: this.readerId_x,
        }
        console.log(`%cEFT 请求参数:`, 'color: #00f;', rD)

        const RESULT = this.$tool.dsbridge_call(this.$tool.dsbridge_map.eftRefund, rD)
        console.log(`%cEFT result:`, 'color: #00f;', RESULT)
        if (RESULT === 'error') {
          this.$message.error(this.$t('pay.eftRefundFailed'))
          reject()
        } else {
          resolve()
        }
        
      })
    },
    // #endregion

    // #region 撤销
    // 撤销结算
    async cancelOrderClick() {
      await this.judgeCart()
      const { id, status } = this.orderData
      if ([8, 9, 10].includes(status)) {
        this.$refs.DialogKey.open({
          orderId: id,
          sceneType: 1,
          onConfirm: this.sendAjax_cancelCalc
        })
      } else if (status === 100) {
        this.refundOrderClick()
      } else {
        this.sendAjax_cancelCalc()
      }
    },
    async sendAjax_cancelCalc() {
      const ORDER = this.orderData

      // 查询是否有eft支付的支付订单
      const _Rs = await this.getData('order', {
        parentOrderId: ORDER.id,
        payed: true,
        returnCash: false,
        eftPay: true,
        subOrder: false,
      })
      if (_Rs && _Rs.length) {
        await Promise.all(_Rs.forEach(x1 => {
          const { id: orderId, payType, userCost } = x1
          return this.sendAjax_eftRefund({ orderId, payType, userCost })
        })).then(() => {
          this.sendAjax_cancelCalc_send(ORDER)
        }).catch(() => {
          this.$message.error('EFT多次退款失败！')
        })
      } else {
        this.sendAjax_cancelCalc_send(ORDER)
      }
    },
    sendAjax_cancelCalc_send(ORDER) {
      this.judgeCashPayed(ORDER)

      this.$api.payment_cancel({
        shopId: this.currentShopId,
        id: ORDER.id,
      }).then(res => {
        if (res.status == 0) {
          this.$router.go(-1)
        } else { this._status(res) }
      })
    },
    // #endregion

    // #region 初始化
    // 获取已生成的子订单
    async getSubOrder() {
      const _Rs = await this.getData('order', {
        shopId: this.currentShopId,
        parentOrderId: this.tableData.orderId,
        subOrder: true,
      })
      let _R = _Rs.reverse()
      console.log(`%c已生成的子订单:`, 'color: #f00;', _R)
      this.childOrders = []
      if (_R.length) {
        _R.forEach((x1, i1) => {
          let cartItems = []

          x1.customerObj = {
            customerId: '',
            customerName: '',
            allCoupons: [],
            okCouponCodes: [],
            failedCouponCodes: [],
          }

          if (x1.ticketCodeList.length) {
            x1.couponsArr = []
            x1.ticketCodeList.forEach(x2 => {
              let couponItem = JSON.parse(JSON.stringify(COUPON_EMPTY))
              couponItem.code = x2
              x1.couponsArr.push(couponItem)
            })
          } else if (x1.payed) {
            x1.couponsArr = [{
              ...JSON.parse(JSON.stringify(COUPON_EMPTY)),
              code: this.$t('coupon.noCoupon')
            }]
          } else {
            x1.couponsArr = [JSON.parse(JSON.stringify(COUPON_EMPTY))]
          }

          x1.isCouponOk = true

          this.$set(this.childOrders, i1, x1)
        })
        this.childOrderCostCalc()
        console.log(`%c已生成的子订单:`, 'color: #f0f;', this.childOrders)
      }
    },
    // 判断购物车是否已经存在
    async judgeCart() {
      let { row, column, uniqueCode, orderId } = this.tableData
      let rD = {
        shopId: this.currentShopId,
        filterCheckoutOrderItem: true,
      }
      if (orderId) {
        rD.id = orderId
      } else {
        rD.foodTableKey = `${row}:${column}:${uniqueCode}`
      }
      const _Rs = await this.getData('order', rD)
      if (_Rs.length) {
        this.orderData = _Rs[0]
        console.log(`%c原订单:`, 'color: #f00;', this.orderData)

        // 当从订单管理跳转，需要填补其他参数
        if (orderId && (!row || !column || !uniqueCode)) {
          this.tableData = {
            row: this.orderData.tableRow,
            column: this.orderData.tableColumn,
            uniqueCode: this.orderData.uniqueCode,
            orderId: this.orderData.id,
          }
        }

      } else {
        this.clearPage()
      }

      return !!_Rs.length
    },
    // 初始化
    async init() {
      let { oid, c, r, uid } = this.$route.query

      this.tableData = {
        row: Number(r),
        column: Number(c),
        uniqueCode: Number(uid),
        orderId: Number(oid)
      }

      await this.judgeCart()
      await this.getSubOrder()

      // #region 如果订单已经绑定了会员ID则显示
      this.childOrders.forEach((x1, i1) => {
        if (x1 && x1.id && x1.customerId) {
          const { id, customerId } = x1

          const rD = {
            companyId: this.shop_x.companyId,
            // status: 0,
            id: customerId
          }
          this.$api.user_info_get(rD).then(res => {
            if (res.status == 0) {
              let _Rs = res.data
              if (_Rs.length) {
          
                this.orderBindCustomerCallback({
                  orderId: id,
                  customerId,
                  customerName: _Rs[0].nickName || _Rs[0].name,
                })

              } else {
                this.$message.warning('未查询到顾客信息！')
              }
            } else { this._status(res) }
          })
          
        }
      })
      // #endregion
    },
    clearPage() {
      // this.tableData = {}, // 餐桌
      this.orderData = {}, // 订单

      this.childOrders = [
        {},
      ] // 所有订单的集合
    },
    // #endregion
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fromPage = from.name
      vm.init()
    })
  },
  beforeRouteLeave(to, from, next) {
    clearTimeout(this.clearPaymentTimer)
    this.clearPage()
    next()
  },
}
</script>

<style lang='scss' scoped>
.filtergray{color: #999!important;}


// .wrapper-calcway{padding-left: 20px;box-sizing: border-box;}
.section-navs{
  height: 80px;background: #fff;padding: 0 10px;margin-bottom: 20px;position: relative;
  .back-btn{
    padding: 0 10px;width: auto;height: 80px;white-space: nowrap;font-weight: bold;
    .arrow{width: 24px;height: 24px;margin-right: 12px;}
  }

  .cancel-btn{margin-left:20px;min-width: 130px;}
  .code{
    line-height: 30px;
    .coupon-text{width: 100%;}
  }
  .iconadd{position: absolute;top: 0;bottom: 0;margin: auto;right: 0;width: 30px;height: 30px;padding: 25px 20px;}
}

.section-cons{
  height: calc(100% - 100px);margin-left: 20px;width: calc(100% - 20px);
  .section-conbox{padding-right: 20px;min-width: 25%;box-sizing: border-box;}
}
.section-con{
  background: #fff;padding: 20px;box-sizing: border-box;position: relative;overflow-y: scroll;
  .iconsubtract{position: absolute;width: 24px;height: 24px;top: 4px;right: 4px;z-index: 2;}
  .iconsplice{
    width: 80px;height: 30px;margin: 0 auto;
    border: 1px solid #374978;border-radius: 4px;box-sizing: border-box;
  }
  .iconsplice2{border: none;}
  .section-scroll{
    min-height: 140px;
    overflow: hidden scroll;
    border-bottom: 1px solid #DFDFDF;
  }
  .section-orderNo{
    min-height: 40px;line-height: 40px;
    .customer{max-width: calc(100% - 60px);}
    .customer2{max-width: calc(100% - 120px);}
    .orderNo{min-width: 60px;text-align: right;}
    .btn{min-width: 70px;}
  }
  .section-orderNo2{padding: 10px 0;}
  .section-orderNo3 .orderNo{text-align: left;}
  .section-coupon{
    padding-bottom: 20px;box-sizing: border-box;position: relative;
    .left{min-width: 36px;height: 40px;position: absolute;}
    .right{min-width: 280px;}
    .input{
      max-width: 220px;height: 40px;line-height: 40px;box-sizing: border-box;
      border: 1px solid #374978;padding: 0 20px;border-radius: 2px;color: #777;
    }
    .input::placeholder{color: #777;}
    .text{height: 46px;line-height: 46px;}
    .iconcoupon{width:24px;height:24px;margin-left:20px;}
  }
  .section-items{
    .item{border-top: 1px solid #DFDFDF;padding: 10px 0;} // min-height: 70px;
    .checkicon{width:20px;height:20px;margin: 8px 20px 8px 0;}
    .num{width: 60px;text-align: right;}
    .text{line-height: 36px;}
    .price{width: 160px;text-align: right;}
  }
  .section-total{
    min-height: 68px;padding: 10px;
    // max-width: 260px;
    .text{height: 24px;line-height: 24px;}
    .pad{padding-left: 20px;}
    .edit-btn{width: 80px;height: 30px;}
  }
  .section-btns{
    height: 50px;margin: 0 auto;
    .btn{margin-left:30px;}
  }
}
.section-con-m{
  padding: 10px;
  .section-coupon{
    padding-bottom: 0;
    .left{height: 30px;position: initial;}
    .right{max-width: 280px;min-width: auto;overflow-x: hidden;}
    .input{
      height: 30px;line-height: 30px;padding: 0 10px;font-size: 14px;
    }
    .text{font-size: 12px;}
    .iconcoupon{margin-left:4px;}
  }
  .section-items{
    .checkicon{margin: 8px 8px 8px 0;}
    .name{font-size: 16px;}
    .num{width: 20px;margin-left: 10px;font-size: 12px;}
    .text{line-height: 36px;font-size: 14px;}
    .item>div:last-child{position: relative;}
    .spec{font-size: 12px;position: absolute;width: calc(100% - 60px);left: 0;bottom: 0;}
  }
  .section-total{
    min-height: auto;padding: 20px 0;
    // .text{margin: 4px 0;}
    .pad{padding-left: 10px;}
  }
  .section-btns{
    .btn:first-child{margin-left: 0;}
    .btn{margin-left:10px;width: 46%;}
  }
}

.mydialog-del{
  padding: 90px 50px;
  .text{min-height: 40px;line-height: 40px;text-align: center;word-break: keep-all;}
}

// 选择分钱方案
.mydialog1{
  padding: 0 40px;
  .info{height: 64px;line-height: 64px;}
  .info div:last-child{margin-left: 30px;}
  /deep/.el-tabs{
    display: flex;align-items: center;flex-direction: column;
    .el-tabs__item{font-size: 20px;}
    .el-tabs__item.is-active{background: transparent!important;color: #374978;}
    .el-tabs__active-bar{background-color: #374978;height: 4px;border-radius: 2px;}
    .el-tabs__nav-wrap::after {content: none;}
  }
  .input{
    width: 620px;height: 50px;line-height: 50px;margin-bottom: 20px;padding: 0 20px;text-align: left;
    border: 1px solid #979797;border-radius: 4px;box-sizing: border-box;
    &.active.inputable::after{right: auto;left: 20px;}
  }

  .inputallleftcash{position: absolute;right: 0;top: 90px;}
}


.mydialog-pay{
  padding: 0 80px;
  .item{width: 180px;height: 200px;}
  .item:nth-child(2n){background: #0ff;}
  .item:nth-child(2n+1){background: #f0f;}

  .pay-result{width:60px;height:60px;border-radius: 50%;padding: 60px;}
  .result-btn{font-size: 18px;margin-top: 120px;}
}

.wrapper-calcway{
  /* 定义滚动条样式 */
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: transparent;
    position: absolute;
    top: 0;
  }
  
  /*定义滚动条轨道 内阴影+圆角*/
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 0px rgba(240, 240, 240, .5);
    border-radius: 10px;
    background-color: rgba(240, 240, 240, .5);
  }
  
  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 0px #aaa;
    background-color: #aaa;
  }
}

/deep/.el-dialog,
.section-cons{
  /* 定义滚动条样式 */
  ::-webkit-scrollbar {
    width: 0;
    height: 0;
    background-color: transparent;
  }
  
  /*定义滚动条轨道 内阴影+圆角*/
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 0px rgba(240, 240, 240, .5);
    border-radius: 10px;
    background-color: rgba(240, 240, 240, .5);
  }
  
  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 0px rgba(240, 240, 240, .5);
    background-color: rgba(240, 240, 240, .5);
  }
}
</style>